import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import { CircleArrowHorizontalScroller } from '@sgcmpteltd/uikit-react';
import {
  getClosestItemScrollDistance,
} from '@sgcmpteltd/uikit-react/components/horizontal-scroller';
import cx from 'clsx';
import type { ReactElement } from 'react';
import { useEffect, useRef } from 'react';

import {
  HORIZONTAL_SCROLLER_SCROLL_DEBOUNCE_WAIT_MSEC,
  HORIZONTAL_SCROLLER_SCROLLEND_TOLERANCE,
} from '@/constants/component';

import styles from './styles.module.scss';
import type { Component, ScrollItemElementList } from './types';

export const CoverLinkList: Component = ({
  children,
  scrollDistance,
  contentContainerClassName,
  arrowCentered,
  isShow = true,
  containerListClassName,
  isLargeHeight,
}) => {
  const { isIpadMini } = useScreenDetect();
  const isIpadMiniMode = isIpadMini();
  const scrollContentContainerRef = useRef<HTMLDivElement>(null);
  const scrollItemElementListRef = useRef<ScrollItemElementList>([]);
  const childrenWithKey = children.map<[string, ReactElement]>((
    child,
    index,
  ) => [
    `cover-link-item-${index}`,
    child,
  ]);
  const listContent = (
    <div className={cx(
      !isIpadMiniMode && styles.containerCoverLinkList,
      isShow && styles.isShow,
    )}>
      <ul className={cx(
        styles.listCoverLinkItem,
        containerListClassName,
      )}>
        {
          childrenWithKey.map(([key, child], index) => (
            <li
              key={key}
              ref={(el) => {
                scrollItemElementListRef.current[index] = el;
              }}
              className={cx(!isIpadMiniMode && styles.itemCoverLinkItem)}>
              {child}
            </li>
          ))
        }
      </ul>
    </div>
  );

  useEffect(() => {
    if (scrollContentContainerRef.current) {
      scrollContentContainerRef.current.scrollLeft = 1;
      scrollContentContainerRef.current.scrollLeft = 0;
    }
  }, []);

  return isIpadMiniMode
    ? (
      <CircleArrowHorizontalScroller
        containerSideBlurClassName={cx(
          styles.containerSideBlur,
          arrowCentered ? '' : styles.isHeight,
          isLargeHeight ? styles.isLargeHeight : '',
        )}
        contentContainerClassName={cx(
          styles.containerScroller,
          isShow && styles.isShow,
          contentContainerClassName,
        )}
        contentContainerElRef={scrollContentContainerRef}
        scrollDebounceWaitMsec={HORIZONTAL_SCROLLER_SCROLL_DEBOUNCE_WAIT_MSEC}
        scrollDistance={
          scrollDistance === undefined
            ? ({
              clientWidth,
              isBack,
              pageLeft,
              scrollLeft,
            }) => getClosestItemScrollDistance({
              clientWidth,
              isBack,
              pageLeft,
              scrollLeft,
              scrollItemElementList: scrollItemElementListRef.current,
              defaultScrollDistance: clientWidth - 20,
            })
            : scrollDistance
        }
        scrollEndTolerance={HORIZONTAL_SCROLLER_SCROLLEND_TOLERANCE}
        autoSnapScrollEnd>
        {listContent}
      </CircleArrowHorizontalScroller>
    )
    : listContent;
};
